import { createRouter, createWebHashHistory } from "vue-router";
import main from "@/views/main/main.vue";
import mainError from "@/views/main/mainError.vue";
import sbcpInpInqNdPolOtpt from "@/views/cargIns/sbcpInpInqNdPolOtpt.vue";
import insurEstForm from "@/views/cargIns/insurEstForm.vue";
import subsRstList from "@/views/cargIns/subsRstList.vue";
import getPolList from "@/views/cargIns/getPolList.vue";
import unpaidList from "@/views/cargIns/unpaidList.vue";
import subsChangeForm from "@/views/cargIns/subsChangeForm.vue";

import insursumCargoidm from "@/views/content/insursumCargoidm.vue";
import cargotarProdguid from "@/views/content/cargotarProdguid.vue";
import blaninsurProdguid from "@/views/content/blaninsurProdguid.vue";
import condcovProdguid from "@/views/content/condcovProdguid.vue";
import insurstrtProdguid from "@/views/content/insurstrtProdguid.vue";
import premcalProdguid from "@/views/content/premcalProdguid.vue";
import termsCond from "@/views/content/termsCond.vue";
import insursumTrs from "@/views/content/insursumTrs.vue";
import clmlossTrs from "@/views/content/clmlossTrs.vue";
import traninsurepoint from "@/views/content/traninsurepoint.vue";
import marinensursumCargoidm from "@/views/content/marinensursumCargoidm.vue";
import prodintroCargoidm from "@/views/content/prodintroCargoidm.vue";
import cginsurepoint from "@/views/content/cginsurepoint.vue";
import noticeBd from "@/views/content/noticeBd.vue";
import precData from "@/views/content/precData.vue";
import docdownData from "@/views/content/docdownData.vue";
import contactpoint from "@/views/content/contactpoint.vue";

import lostIdPwd from "@/views/member/lostIdPwd.vue";
import mbrInfo from "@/views/main/mbrInfo.vue";
import mbrChk from "@/views/member/mbrChk.vue";
import gombrRegi from "@/views/member/gombrRegi.vue";
import admMgr from "@/views/member/admMgr.vue";
import confirUsrDeta from "@/views/member/confirUsrDeta.vue";
import staMon from "@/views/cargIns/staMon.vue";
import staItem from "@/views/cargIns/staItem.vue";
import staLoc from "@/views/cargIns/staLoc.vue";

import chngNotice from "@/views/admin/chngNotice.vue";
import mbrInfoUpt from "@/views/member/mbrInfoUpt.vue";

import { sessionUserInfo, load } from "@/common/sessionFactory";
import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useRouter, useRoute } from "vue-router";
// import { useStore } from 'vuex';

import store from "@/store";

// const store = useStore();

const routes = [
  {
    // 적하 메인페이지
    path: "/",
    name: "main",
    component: main,
  },
  // 청약 입력/조회 및 증권 출력
  {
    path: "/sbcpInpInqNdPolOtpt",
    name: "sbcpInpInqNdPolOtpt",
    component: sbcpInpInqNdPolOtpt,
    meta: { authorization: ["C", "2"] },
  },
  {
    // 보험료 견적
    path: "/insurEstForm",
    name: "insurEstForm",
    component: insurEstForm,
  },
  {
    // 청약 결과 조회
    path: "/subsRstList",
    name: "subsRstList",
    component: subsRstList,
    meta: { authorization: ["C"] },
  },
  {
    // 계약 조회 및 증권 출력
    path: "/getPolList",
    name: "getPolList",
    component: getPolList,
    meta: { authorization: ["C"] },
  },
  {
    // 미납조회
    path: "/unpaidList",
    name: "unpaidList",
    component: unpaidList,
    meta: { authorization: ["C"] },
  },
  {
    // 증권 간략정정
    path: "/subsChangeForm",
    name: "subsChangeForm",
    component: subsChangeForm,
    meta: { authorization: ["C"] },
  },
  {
    // 계약 월별 통계
    path: "/staMon",
    name: "staMon",
    component: staMon,
    meta: { authorization: ["C"] },
  },
  {
    // 계약 품목별 통계
    path: "/staItem",
    name: "staItem",
    component: staItem,
    meta: { authorization: ["C"] },
  },
  {
    // 계약 지역별 통계
    path: "/staLoc",
    name: "staLoc",
    component: staLoc,
    meta: { authorization: ["C"] },
  },
  // ID PWD 찾기
  {
    path: "/lostIdPwd",
    name: "lostIdPwd",
    component: lostIdPwd,
  },
  // 인터넷약정서
  {
    path: "/termsCond",
    name: "termsCond",
    component: termsCond,
  },
  // 관리자 페이지
  {
    path: "/admMgr",
    name: "admMgr",
    component: admMgr,
    meta: { authorization: ["A"] },
  },
  // 미승인 회원 인증 페이지
  {
    path: "/confirUsrDeta",
    name: "confirUsrDeta",
    component: confirUsrDeta,
    meta: { authorization: ["A"] },
  },
  //관리자 페이지 수정
  {
    path: "/mbrInfoUpt",
    name: "mbrInfoUpt",
    component: mbrInfoUpt,
    meta: { authorization: ["A"] },
    props: true,
  },
  // 회원정보 페이지
  {
    path: "/mbrInfo",
    name: "mbrInfo",
    component: mbrInfo,
    meta: { authorization: ["C", "A"] },
  },
  // 회원가입체크
  {
    path: "/mbrChk",
    name: "mbrChk",
    component: mbrChk,
  },
  // 회원가입
  {
    path: "/gombrRegi",
    name: "gombrRegi",
    component: gombrRegi,
  },
  // 적하보험의 개요
  {
    path: "/insursumCargoidm",
    name: "insursumCargoidm",
    component: insursumCargoidm,
  },
  // 적하보험 가입대상
  {
    path: "/cargotarProdguid",
    name: "cargotarProdguid",
    component: cargotarProdguid,
  },
  // 입력전 알아야할 사항
  {
    path: "/contactpoint",
    name: "contactpoint",
    component: contactpoint,
  },
  // 보험료 산출 및 납입
  {
    path: "/premcalProdguid",
    name: "premcalProdguid",
    component: premcalProdguid,
  },
  // 보험의 개시와 종료
  {
    path: "/insurstrtProdguid",
    name: "insurstrtProdguid",
    component: insurstrtProdguid,
  },
  // 조건별 담보안내
  {
    path: "/condcovProdguid",
    name: "condcovProdguid",
    component: condcovProdguid,
  },
  // 포괄보험안내
  {
    path: "/blaninsurProdguid",
    name: "blaninsurProdguid",
    component: blaninsurProdguid,
  },
  // 운송보험의개요
  {
    path: "/insursumTrs",
    name: "insursumTrs",
    component: insursumTrs,
  },
  // 보상하는손해
  {
    path: "/clmlossTrs",
    name: "clmlossTrs",
    component: clmlossTrs,
  },
  // 알아두실사항
  {
    path: "/traninsurepoint",
    name: "traninsurepoint",
    component: traninsurepoint,
  },
  // 해상배상책임보험의개요
  {
    path: "/marinensursumCargoidm",
    name: "marinensursumCargoidm",
    component: marinensursumCargoidm,
  },
  // 해상배상책임판매상품소개
  {
    path: "/prodintroCargoidm",
    name: "prodintroCargoidm",
    component: prodintroCargoidm,
  },
  // 해상배상책임 알아두실사항
  {
    path: "/cginsurepoint",
    name: "cginsurepoint",
    component: cginsurepoint,
  },
  // 자료실(공지사항)
  {
    path: "/noticeBd",
    name: "noticeBd",
    component: noticeBd,
  },
  // 자료실(약관 및 판례)
  {
    path: "/precData",
    name: "precData",
    component: precData,
  },
  // 자료실(주요서식)
  {
    path: "/docdownData",
    name: "docdownData",
    component: docdownData,
  },
  // 관리자 공지사항 입력
  {
    path: "/chngNotice",
    name: "chngNotice",
    component: chngNotice,
    props: true,
  },
  // 404 페이지
  {
    path: "/error",
    name: "mainError",
    component: mainError,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

router.beforeEach(async (to, from, next) => {
  // const authState = sessionUserInfo?.userInfo?.ind_corp_typ_cd;
  // const loginTypeCd = sessionUserInfo?.userInfo?.login_typ_cd;
  const moveTypeCd = sessionUserInfo?.userInfo?.moveTypeCd;
  const swalAlert = inject("swalAlert");
  const axios = inject("axios");

  const { authorization } = to.meta; // undefiend, [], ["A"], ["C"]
  console.log("authorization-->" + authorization);

  if (to.name != "main" && authorization) {
    var param = {};
    param.moveTypeCd = moveTypeCd;
    param.authorization = to.meta.authorization;
    const pageData = await axios.json("/checkPageAth.do", param);
    console.log("[checkPageAth] response:", pageData);

    if (pageData.data.standCd != "0000") {
      if (pageData.data.standCd == "1000") {
        return swalAlert(pageData.data.msg).then(() => {
          return next({ path: "/" });
        });
      } else {
        await swalAlert(pageData.data.msg);
        return next(false);
      }
    } else {
      await load();
      //세션 만료시 header 변경
      if (!_.isEmpty(sessionUserInfo)) {
        store.commit("common/chgLginChk", true);
        store.commit(
          "common/lginAuthChk",
          sessionUserInfo?.userInfo?.ind_corp_typ_cd
        );
        store.commit(
          "common/loginTypeCdChk",
          sessionUserInfo?.userInfo?.login_typ_cd
        );
      } else {
        store.commit("common/chgLginChk", false);
        store.commit("common/lginAuthChk", "");
        store.commit("common/loginTypeCdChk", "");
      }

      $("#header .siteMap").fadeOut(100);
      next();
    }
  } else {
    await load();
    //세션 만료시 header 변경
    if (!_.isEmpty(sessionUserInfo)) {
      store.commit("common/chgLginChk", true);
      store.commit(
        "common/lginAuthChk",
        sessionUserInfo?.userInfo?.ind_corp_typ_cd
      );
      store.commit(
        "common/loginTypeCdChk",
        sessionUserInfo?.userInfo?.login_typ_cd
      );
    } else {
      store.commit("common/chgLginChk", false);
      store.commit("common/lginAuthChk", "");
      store.commit("common/loginTypeCdChk", "");
    }

    $("#header .siteMap").fadeOut(100);
    next();
  }

  ///
  // if (authorization) {
  //   // 있는경우
  //   if (authorization.length != 0 && _.isEmpty(authState)) {
  //     return swalAlert("로그인이 필요한 페이지입니다.").then((result) => {
  //       return next({ path: "/" });
  //     });
  //   } else {
  //     if (authState == "C") {
  //       if (_.isEqual(authorization, ["A"])) {
  //         return swalAlert("관리자 권한이 없습니다.");
  //       }
  //       if (loginTypeCd == "1" && moveTypeCd != "Y") {
  //         if (_.isEqual(authorization, ["C", "2"])) {
  //           return swalAlert("청약로그인이 필요한 페이지 입니다");
  //         }
  //       }
  //     } else if (authState == "A") {
  //       if (_.isEqual(authorization, ["C", "2"])) {
  //         return swalAlert("관리자는 접근 불가능합니다.");
  //       }
  //     }
  //   }
  // }
});

export default router;
